import type { HTMLAttributes } from "react";
import "./layout.css";

export interface NextBillNoteProps extends HTMLAttributes<HTMLDivElement> {
  amount: string;
  currency: string;
  billedAt: string;
  renewalAt?: string | null;
}

/** Shared next-invoice copy for org billing and the platform admin licence card. */
export function NextBillNote({ amount, currency, billedAt, renewalAt, className, ...rest }: NextBillNoteProps) {
  const dateTimeFormat: Intl.DateTimeFormatOptions = {
    dateStyle: "short",
    timeStyle: "short",
  };
  const processDate = new Date(billedAt).toLocaleString(undefined, dateTimeFormat);
  const renewalDate = renewalAt ? new Date(renewalAt).toLocaleString(undefined, dateTimeFormat) : null;
  return (
    <div className={["ui-next-bill", className].filter(Boolean).join(" ")} {...rest}>
      <p className="ui-next-bill__kicker">Next amount to be billed</p>
      <p className="ui-next-bill__amount">{amount} {currency}</p>
      <p className="ui-next-bill__date">Payment will be processed on {processDate}</p>
      {renewalDate && renewalDate !== processDate ? (
        <p className="ui-next-bill__date">Access renews on {renewalDate}</p>
      ) : null}
    </div>
  );
}
